<template>
  <div class="gamehistory">
    <v-container class="pt-0">
      <span class="headline">{{$t('publicGame.title')}}</span>
    </v-container>
    <v-container>
      <v-row>
        <v-col>
          <v-btn to="/competitions/public" class="">
            <v-icon left>mdi-earth</v-icon>{{$t('publicGame.back-to-overview')}}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="gameInstance && gameInstance.youAreParticipating === false">
      <v-row>
        <v-col>
          <participate-button :coinFee="gameInstance.participationCoinFee" @click="join" :disabled="loading"/>
        </v-col>
      </v-row>
    </v-container>
    <game-instance-info v-if="gameInstance" :gameInstance="gameInstance" :game="game" :platform="platform"/>
    <v-container v-if="gameInstance">
      <v-row>
        <v-col v-if="gameInstance.youAreParticipating === false">
          <participate-button :coinFee="gameInstance.participationCoinFee" @click="join" :disabled="loading"/>
        </v-col>
        <v-col v-if="gameInstance.youAreParticipating === true">
          <v-btn class="primary" @click="openGameinstance" :disabled="loading">
            <multi-icon left
              :icon="getGameTypeIcon(gameInstance.type)"
              :rightBottomIcon="getPlatformIcon(gameInstance.platform)"
            />
            <span class="ml-1">{{$t('publicGame.open')}}</span>
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="gameInstance.description">
        <v-col>
          <v-btn to="/competitions/public" class="">
            <v-icon left>mdi-earth</v-icon>{{$t('publicGame.back-to-overview')}}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { EVENT_REFRESH_DATA } from "@/plugins/eventbus";
import GameInstanceInfo from "@/widgets/content/GameInstanceInfo";
import platformMixins from "@/mixins/platformMixins";
import gameTypeMixin from "@/mixins/gameTypeMixin";
import ParticipateButton from '@/widgets/ParticipateButton.vue';

export default {
  name: "PublicGame",
  mixins: [platformMixins, gameTypeMixin],
  components: {GameInstanceInfo, ParticipateButton},
  props: {
    gameUID: String
  },
  data: function() {
    return {
      loading: false,
      gameInstance: undefined,
      game: undefined,
      platform: undefined,
    };
  },
  computed: {
  },
  watch: {},
  mounted() {
    this.refresh();
    this.$eventBus.$on(EVENT_REFRESH_DATA, this.onRefreshData);
  },
  beforeDestroy() {
    this.$eventBus.$off(EVENT_REFRESH_DATA, this.onRefreshData);
  },
  methods: {
    onRefreshData() {
      this.refresh();
    },
    refresh() {
      this.loading = true;
      this.$api
        .getPublicGameInfo(this.gameUID)
        .then(response => {
          this.loading = false;
          let data = response.data;
          this.gameInstance = data.info;
          this.game = data.game;
          this.platform = data.platform;
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
    },
    join() {
      this.loading = true;
      this.$api.joinGameinstance(this.gameInstance.uid).then(() => {
          this.loading = false;
          this.$router.push({ name: 'competition', params: { gameUID: this.gameInstance.uid } })
          this.$eventBus.$emit(EVENT_REFRESH_DATA);
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
    },
    openGameinstance() {
      this.$router.push({ name: 'competition', params: { gameUID: this.gameInstance.uid } })
    }
  }
};
</script>
